export const OVERSEAS_PREFECTURE_ID = 99; // 海外の都道府県Id
export const MAX_CITY_SELECTABLE_LENGTH = 25; // 選択できる最大の市区町村数
export const MAX_STATION_SELECTABLE_LENGTH = 10; // 選択できる最大の駅数
export const MAX_PREFECTURE_SELECTABLE_LENGTH = 3; // 選択できる最大の都道府県数

export type ActionProps =
  | { type: "selectPref"; value: number; name: string }
  | { type: "unSelectPref"; value: number }
  | { type: "selectCities"; value: number; name: string; prefectureId: number }
  | { type: "unSelectCities"; value: number; prefectureId: number }
  | { type: "selectLine"; value: number; name: string; prefectureId: number }
  | { type: "unSelectLine"; value: number; prefectureId: number }
  | { type: "selectStations"; value: number; name: string; prefectureId: number }
  | { type: "unSelectStations"; value: number; prefectureId: number }
  | { type: "toggleShowStations"; value: boolean; prefectureId: number }
  | { type: "saveStations"; value: [string, number][]; prefectureId: number };

export type formStateProps = Record<
  number,
  {
    // 都道府県ID
    name: string; // 都道府県名
    cities: Record<number, { name: string }>; // {市区町村ID: 市区町村名}
    line: Record<number, { name: string }>; // {路線ID: 路線名}
    showStations: boolean; // 駅情報が選択されている場合true
    stations: Record<number, { name: string }>; // {駅ID: 駅名}
    stationArray: [string, number][]; // lineに紐つく全ての駅情報
  }
>;

/*
選択条件のstate管理
*/
export const initialState: formStateProps = {};

// 追加された検索条件をstateに保存
export const formStateReducer = (state: formStateProps, action: ActionProps): formStateProps => {
  const addObjectItem = ({
    object,
    value,
    name,
    targetName,
    targetPrefectureId,
  }: {
    object: Record<number, { name: string }>;
    value: number;
    name: string;
    targetName: string;
    targetPrefectureId: number;
  }) => {
    const newTargetObject = { ...object, [value]: { name } };
    return { ...state[targetPrefectureId], [targetName]: newTargetObject };
  };

  const removeObjectItem = ({
    object,
    value,
    targetName,
    targetPrefectureId,
  }: {
    object: Record<number, { name: string }>;
    value: number;
    targetName: string;
    targetPrefectureId: number;
  }) => {
    const prevObject = object;
    delete prevObject[value];
    return { ...state[targetPrefectureId], [targetName]: prevObject };
  };

  const addItem = ({
    value,
    name,
    targetName,
    targetPrefectureId,
  }: {
    value: number;
    name: string;
    targetName: string;
    targetPrefectureId: number;
  }) => {
    const item = { [value]: { name } };
    return { ...state[targetPrefectureId], [targetName]: item };
  };

  switch (action.type) {
    case "selectPref":
      return {
        ...state,
        [action.value]: {
          name: action.name,
          cities: {},
          line: {},
          showStations: false,
          stations: {},
          stationArray: [],
        },
      };
    case "unSelectPref": {
      const prevPrefectureObject = state;
      delete prevPrefectureObject[action.value];
      return { ...prevPrefectureObject };
    }
    case "selectCities":
      return {
        ...state,
        [action.prefectureId]: addObjectItem({
          object: state[action.prefectureId].cities,
          value: action.value,
          name: action.name,
          targetName: "cities",
          targetPrefectureId: action.prefectureId,
        }),
      };
    case "unSelectCities":
      return {
        ...state,
        [action.prefectureId]: removeObjectItem({
          object: state[action.prefectureId].cities,
          value: action.value,
          targetName: "cities",
          targetPrefectureId: action.prefectureId,
        }),
      };
    case "selectLine":
      return {
        ...state,
        [action.prefectureId]: addItem({
          value: action.value,
          name: action.name,
          targetName: "line",
          targetPrefectureId: action.prefectureId,
        }),
      };
    case "unSelectLine": {
      const newLineObject = { ...state[action.prefectureId], line: {} };
      return { ...state, [action.prefectureId]: newLineObject };
    }
    case "selectStations":
      return {
        ...state,
        [action.prefectureId]: addObjectItem({
          object: state[action.prefectureId].stations,
          value: action.value,
          name: action.name,
          targetName: "stations",
          targetPrefectureId: action.prefectureId,
        }),
      };
    case "unSelectStations":
      return {
        ...state,
        [action.prefectureId]: removeObjectItem({
          object: state[action.prefectureId].stations,
          value: action.value,
          targetName: "stations",
          targetPrefectureId: action.prefectureId,
        }),
      };
    case "toggleShowStations": {
      const newValue = { ...state[action.prefectureId], showStations: action.value };
      return { ...state, [action.prefectureId]: newValue };
    }
    case "saveStations": {
      const newStations = { ...state[action.prefectureId], stationArray: action.value };
      return { ...state, [action.prefectureId]: newStations };
    }
    default:
      return state;
  }
};
